import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, NavLink } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../UserContext/AuthProvider";
import { Dropdown } from "react-bootstrap";
import "./Header.css";

const Header = () => {
  const { user, handleLogOut } = useContext(AuthContext);
  const logOutUser = () => {
    handleLogOut()
      .then(() => {})
      .catch(() => {});
  };
  return (
    <header>
      <Navbar className="py-3 text-white bg-black" expand="lg">
        <Container>
          <Link className="text-decoration-none text-white" to="/">
            <div className="d-flex align-items-center">
              <img src="logo.png" alt="" width="50px" />{" "}
              <h4 className="fw-bolder mb-0 ms-2">Code Your Web</h4>
            </div>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto my-2 my-lg-0">
              <NavLink
                className="text-decoration-none fw-bolder px-2 text-white theme_color"
                to="/"
              >
                Home
              </NavLink>
              <NavLink
                className="text-decoration-none fw-bolder px-2 text-white"
                to="/courses"
              >
                Courses
              </NavLink>
              <NavLink
                className="text-decoration-none fw-bolder px-2 text-white"
                to="/FAQ"
              >
                FAQ
              </NavLink>
              <NavLink
                className="text-decoration-none fw-bolder px-2 text-white"
                to="/blog"
              >
                Blog
              </NavLink>
            </Nav>
            <div class="toggle_hhh4 toggle_o8XW toggleChecked_KUUI">
              <div class="toggleTrack_HbNd" role="button" tabindex="-1">
              
                <div class="toggleTrackThumb_K2k9"></div>
              </div>
             
            </div>
            <div className="d-flex">
              {!user && (
                <>
                  <NavLink
                    className="text-decoration-none fw-bolder px-2 text-white"
                    to="/login"
                  >
                    Login
                  </NavLink>
                  <NavLink
                    className="text-decoration-none fw-bolder px-2 text-white"
                    to="/register"
                  >
                    Register
                  </NavLink>
                </>
              )}

              {user && (
                <>
                  <Dropdown>
                    <Dropdown.Toggle
                      className="bg-transparent border-0"
                      id="dropdown-basic"
                    >
                      <img
                        src={user?.photoURL}
                        className="rounded-circle"
                        title={user?.displayName}
                        alt=""
                        width="50px"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="px-2">
                      <h6>Welcome {user?.displayName}</h6>
                      <NavLink
                        to="/profile"
                        className="text-decoration-none py-2 text-black d-block fw-bolder"
                      >
                        Profile
                      </NavLink>
                      <NavLink
                        onClick={logOutUser}
                        className="text-decoration-none text-black py-2 fw-bolder d-block"
                      >
                        Logout
                      </NavLink>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
